import { render, staticRenderFns } from "./BaseFormGroupSwitch.vue?vue&type=template&id=0c517b0c&"
import script from "./BaseFormGroupSwitch.vue?vue&type=script&lang=js&"
export * from "./BaseFormGroupSwitch.vue?vue&type=script&lang=js&"
import style0 from "./BaseFormGroupSwitch.vue?vue&type=style&index=0&id=0c517b0c&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports